/* eslint-disable-next-line ipex-viewer/prefix-babylon-imports */
import { Quaternion, Vector2, Vector3, Vector4, Matrix } from '@inter-ikea-betrakta-babylonjs/core/Maths/math.vector.js';
/* eslint-disable-next-line ipex-viewer/prefix-babylon-imports */
import { Plane } from '@inter-ikea-betrakta-babylonjs/core/Maths/math.plane.js';
Vector2.prototype.toIVector2ToRef = function (ref) {
    ref.x = this.x;
    ref.y = this.y;
    return ref;
};
Vector2.prototype.fromIVector2 = function (val) {
    this.x = val.x;
    this.y = val.y;
    return this;
};
Vector3.prototype.toIVector3ToRef = function (ref) {
    ref.x = this.x;
    ref.y = this.y;
    ref.z = this.z;
    return ref;
};
Vector3.prototype.fromIVector3 = function (val) {
    this.set(val.x, val.y, val.z);
    return this;
};
Vector4.prototype.toIVector4ToRef = function (ref) {
    ref.x = this.x;
    ref.y = this.y;
    ref.z = this.z;
    ref.w = this.w;
    return ref;
};
Vector4.prototype.fromIVector4 = function (val) {
    this.set(val.x, val.y, val.z, val.w);
    return this;
};
Vector4.prototype.toIVector4ToRef = function (ref) {
    ref.x = this.x;
    ref.y = this.y;
    ref.z = this.z;
    ref.w = this.w;
    return ref;
};
Quaternion.prototype.fromIVector4 = function (val) {
    this.set(val.x, val.y, val.z, val.w);
    return this;
};
Quaternion.prototype.toIVector4ToRef = function (ref) {
    ref.x = this.x;
    ref.y = this.y;
    ref.z = this.z;
    ref.w = this.w;
    return ref;
};
Matrix.prototype.toIMatrix4ToRef = function (ref) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const m = this;
    for (let i = 0; i < 4; i++) {
        const row = m.getRow(i);
        ref[i].x = row.x;
        ref[i].y = row.y;
        ref[i].z = row.z;
        ref[i].w = row.w;
    }
    return ref;
};
Matrix.prototype.fromIMatrix4 = function (val) {
    for (let i = 0; i < 4; i++) {
        // This forces us to mark the matrix as updated 4 times. looks like it just sets a few bools tho
        this.setRowFromFloats(i, val[i].x, val[i].y, val[i].z, val[i].w);
    }
    return this;
};
Vector3.Forward = function () {
    return new Vector3(0, 0, -1);
};
Vector3.Backward = function () {
    return new Vector3(0, 0, 1);
};
Vector3.Perpendicular = function (value) {
    if (Math.abs(value.y) < Math.abs(value.x)) {
        return new Vector3(value.z, 0, -value.x);
    }
    else {
        return new Vector3(0, value.z, -value.y);
    }
};
export { Vector2 };
export { Vector3 };
export { Vector4 };
export { Quaternion };
export { Matrix };
export { Plane };
//# sourceMappingURL=Math.extension.js.map